var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFragScenarioList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 32,
    viewBox: "0 0 160 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#6369D1",
    strokeWidth: 2,
    d: "M0 65L0 0 160 0 160 65"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(34.288 15.646)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6369D1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M63.918 34.955L37.26 21.507c-1.156-.602-2.532-.596-3.693.016L6.877 35.619c-.535.281-.874.842-.877 1.452-.002.61.56 1.201 1.093 1.478l26.73 13.62c.05.025.1.05.15.073 1.124.527 2.044.706 3.156.12l26.69-14.096c.535-.283.958-1.257.961-1.867.003-.61-.33-1.166-.862-1.444z",
    transform: "rotate(-117 35.39 36.893)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6369D1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M24.75 20.198l26.828 13.67c1.156.603 2.532.597 3.693-.015L82.868 20.29",
    mask: "url(#zxhn3vex9c)",
    transform: "rotate(-117 53.809 27.257)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#6369D1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M35.343 15.067l26.73 13.62c1.156.602 2.532.596 3.693-.017L93.95 15",
    mask: "url(#zxhn3vex9c)",
    transform: "rotate(-117 64.646 22.067)"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFragScenarioList);
export default __webpack_public_path__ + "static/media/frag_scenario_list.2ae43fa53cc6f539804381d3dc3b7501.svg";
export { ForwardRef as ReactComponent };